import { instagramService } from '@/services/instagram-service'

export interface AnalyticsRefreshResult {
  success: boolean
  message: string
}

/**
 * Refreshes an analytics profile by queuing it for reprocessing
 */
export async function refreshAnalyticsProfile(analyticsId: string): Promise<AnalyticsRefreshResult> {
  try {
    const result = await instagramService.refreshAnalytics(analyticsId)
    
    return {
      success: true,
      message: result.message
    }
    
  } catch (error: any) {
    console.error('Failed to refresh analytics:', error)
    
    // Handle specific error cases
    if (error?.status === 404) {
      return {
        success: false,
        message: "Analytics record not found"
      }
    }
    
    if (error?.status === 403) {
      return {
        success: false,
        message: "You don't have permission to refresh this analytics record"
      }
    }
    
    if (error?.status === 400) {
      return {
        success: false,
        message: error?.response?.detail || error?.response?.message || 'This analytics record cannot be refreshed'
      }
    }
    
    // Generic error message
    return {
      success: false,
      message: "Failed to refresh analytics. Please try again later."
    }
  }
} 